
import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    AM,
    AM_TOLL,
    AM_TOLL_MONTHLY_PLAN,
    APPROVAL_ACTIVITY,
    APPROVAL_PENDING_LIST,
    CALL_LOGS,
    FSE,
    FSE_ACTIVATION_CHECK,
    FSE_INVENTORY,
    FSE_OTP_GENERATE,
    FSE_TAG_TRANSFER,
    INACTIVE_FSE,
    IS_CHECKOUT,
    MARK_ATTENDANCE, NEAREST_PLAZA_FROM_OPERATOR,
    PENDING_ACTIVITY,
    PJP_DETAILS_BY_ID,
    PJP_PENDING_APPROVE,
    PJP_PENDING_LIST,
    PJP_REVIEW,
    SAVE_ACTIVITY,
    SAVE_FSE,
    SAVE_TOLL, SBI_ISSUANCE, SBIIssuance,
    TOLL_FILTER,
    TOLL_LIST, TOLL_PENDING_MEETING,
    TOLL_VIEW,
    TYPES
} from "./type";



export const getActivity = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.FasttagTollActivityType}?type=is_fasttag_toll`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TYPES,
            payload: data.response,
        });
        return true;
    }
};

export const activitySave = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.FasttagTollActivitySave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const markAttendance = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.FasttagTollAttendance}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MARK_ATTENDANCE,
            payload: data.response,
        });
        return data.response;
    }
};

export const getPendingActivity = (accountId = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.FasttagTollPendingActivity}?account_id=${accountId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const isCheckout = (activityId, accountId, pjpId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.FasttagTollIsCheckout}?activity_id=${activityId}&account_id=${accountId}&pjp_id=${pjpId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: IS_CHECKOUT,
            payload: data.response,
        });
        return true;
    }
};

export const saveToll = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.FasttagTollSave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_TOLL,
            payload: data.response,
        });
        return true;
    }
};

export const listToll = (page = 1, searchKey = '', data=[{}], isApproval = 0) => async (dispatch) => {

    const search = window.localStorage.search_account
    if(search){
        searchKey = search
    }
    let roleId = window.localStorage.role_id;
    let urls = `${Config.FasttagTollAccountList}?search_key=${searchKey}&page=${page}&is_approval=${isApproval}&role_id=${roleId}`
    // eslint-disable-next-line array-callback-return
    Object.keys(data[0]).map((val, i) => {
        urls+="&"+val+"="+data[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TOLL_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const tollById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.tollById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TOLL_VIEW,
            payload: data.response,
        });
        return true;
    }
};

export const tollFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.tollFilter}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TOLL_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const approvalPending = (page = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.tollApprovePending}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: APPROVAL_PENDING_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const approvalActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.tollActivityApprove}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: APPROVAL_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getFse = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.FSEDetails}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FSE,
            payload: data.response,
        });
        return true;
    }
};

export const getAM = (visibility = 1, removeSelectedAm = false) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.AMByAsm}?visibility=${visibility}&remove_selected_am=${removeSelectedAm}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: AM,
            payload: data.response,
        });
        return true;
    }
};

export const getAMTollByUserId = (userId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.AmToll}?user_id=${userId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: AM_TOLL,
            payload: data.response,
        });
        return true;
    }
};

export const amMonthlyPlan = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.AmTollMonthlyPlan}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: AM_TOLL_MONTHLY_PLAN,
            payload: data.response,
        });
        return true;
    }
};

export const pjpReview = (status = 1,filter=[{}]) => async (dispatch) => {
    let urls = `${Config.PJPReview}?status=${status}`
    // eslint-disable-next-line array-callback-return
    Object.keys(filter[0]).map((val, i) => {
        urls+="&"+val+"="+filter[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PJP_REVIEW,
            payload: data.response,
        });
        return true;
    }
};

export const pjpPending = (userId, status = 1, filter=[{}]) => async (dispatch) => {
    let urls = `${Config.PJPPendingList}?user_id=${userId}&status=${status}`
    // eslint-disable-next-line array-callback-return
    Object.keys(filter[0]).map((val, i) => {
        urls+="&"+val+"="+filter[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PJP_PENDING_LIST,
            payload: data.response,
        });
        return true;
    }
};

export const pjpPendingApprove = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.PJPPendingApprove}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PJP_PENDING_APPROVE,
            payload: data.response,
        });
        return true;
    }
};

export const fseOtp = (data = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.fseOTPGeneration}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FSE_OTP_GENERATE,
            payload: data.response,
        });
        return true;
    }
};

export const saveFSEs = (data = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveFSEs}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_FSE,
            payload: data?.response?.data,
        });
        return true;
    }
};

export const fseDetailsPJP = (PJPId ) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.FSEsDetailsByPJPId}?pjp_id=${PJPId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PJP_REVIEW,
            payload: data.response,
        });
        return true;
    }
};

export const pjpDetailsById = (PJPId ) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.pjpDetailsById}?id=${PJPId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PJP_DETAILS_BY_ID,
            payload: data.response,
        });
        return true;
    }
};

export const getInactiveFsesRequest = (lat, long, operator ) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.inactiveFseDetails}?lat=${lat}&long=${long}&operator=${operator}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: INACTIVE_FSE,
            payload: data.response?.data,
        });
        return true;
    }
};

export const getFseActivationCheckRequest = (ids) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fseActivationCheck}?operator_ids=${ids}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FSE_ACTIVATION_CHECK,
            payload: data.response?.data,
        });
        return true;
    }
};

export const getFseInventoryRequest = (ids) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fseInventory}?operator_ids=${ids}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FSE_INVENTORY,
            payload: data.response?.data,
        });
        return true;
    }
};

export const getFseTagTransferRequest = (ids) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.fseTagTransfer}?operator_ids=${ids}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: FSE_TAG_TRANSFER,
            payload: data.response?.data,
        });
        return true;
    }
};

export const callLogsRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.callLogs}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CALL_LOGS,
            payload: data.response,
        });
        return true;
    }
};

export const tollPendingMeetingRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.tollPendingMeeting}?account_id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TOLL_PENDING_MEETING,
            payload: data.response,
        });
        return true;
    }
};

export const errorLogs = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.errorLogs}`
    );
    if (res) {
        const { data } = res;
        return true;
    }
};

export const nearestPlazaFromOperatorLocationRequest = (operatorId, plazaId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.nearestPlazaFromOperatorLocation}?operator_id=${operatorId}&plaza_id=${plazaId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: NEAREST_PLAZA_FROM_OPERATOR,
            payload: data.response,
        });
        return true;
    }
};

export const checkSBIIssuanceRequest = (vehicle_no) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.checkSBIIssuance}?vehicle_no=${vehicle_no}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SBI_ISSUANCE,
            payload: data.response?.data,
        });
        return true;
    }
};